type Line = {
  quantity: number;
  part: { quantityInAssembly: number | null };
};

export const getNestedLineQuantity = ({ quantity, part }: Line) =>
  quantity * (part.quantityInAssembly ?? 1);
